export default "__VITE_ASSET__luPWnvk8__"